<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-index="index" let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		@if(instruction.rerPercentage) { <app-instruction-box>{{ instruction.rerPercentage }}% RER</app-instruction-box> }
		@if(instruction.diet) { <app-instruction-box>{{ instruction.diet }}</app-instruction-box> }
		@if(instruction.nutritionMethod !== null) { <app-instruction-box>{{ nutritionMethod[index] }}</app-instruction-box> }
		@if(instruction.nutritionTube !== null) { <app-instruction-box>{{ nutritionTube[index] }}</app-instruction-box> }
	}
</ng-template>